"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Helpers = /** @class */ (function () {
    function Helpers() {
    }
    Object.defineProperty(Helpers, "isBrowser", {
        get: function () {
            return Helpers.simulateBrowser || !!(typeof window !== 'undefined' && window.document);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Helpers, "isNode", {
        get: function () {
            return Helpers.simulateBrowser || !Helpers.isBrowser;
        },
        enumerable: true,
        configurable: true
    });
    Helpers.simulateBrowser = false;
    return Helpers;
}());
exports.Helpers = Helpers;
//# sourceMappingURL=helper.js.map